import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFilePdf,
  faFileWord,
} from "@fortawesome/free-solid-svg-icons";
import TitlePages from "../../layout/TitlePages";
import Modal from "../../layout/Modal/Modal";
import { dataDatosAbiertos } from "../../data/dataTransparencia";
import Breadcrumbs from "../../layout/Breadcrumbs";
import "./DatosAbiertos.css";

const AccordionItem = ({ item, isOpen, onClick }) => {
  const panelId = `da-panel-${item.id}`;
  const headerId = `da-heading-${item.id}`;

  return (
    <div className={`da-accordion-item ${isOpen ? "is-open" : ""}`}>
      <h2 className="da-accordion-header" id={headerId}>
        <button
          className={`da-accordion-button ${isOpen ? "is-open" : ""}`}
          type="button"
          onClick={onClick}
          aria-expanded={isOpen}
          aria-controls={panelId}
        >
          <span className="TITDA">{item.titleItem}</span>
          <svg
            className={`da-chevron-icon ${isOpen ? "is-open" : ""}`}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="22"
            height="22"
            aria-hidden="true"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </h2>
      <div
        id={panelId}
        role="region"
        aria-labelledby={headerId}
        className={`da-accordion-panel ${isOpen ? "is-open" : ""}`}
      >
        <div className="da-accordion-panel-inner">
          <div className="da-items-list">
            {item.children.map((buttonModal) => (
              <ModalButton key={buttonModal.id} buttonModal={buttonModal} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const ModalButton = ({ buttonModal }) => (
  <div className="da-item-row-wrapper">
    <button
      type="button"
      className="da-item-row"
      data-bs-toggle="modal"
      data-bs-target={`#${buttonModal.idModal}`}
    >
      <svg
        className="da-doc-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        width="18"
        height="18"
        aria-hidden="true"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <line x1="10" y1="9" x2="8" y2="9" />
      </svg>
      <span className="da-item-title">{buttonModal.titleModal}</span>
    </button>
    <Modal
      idModal={buttonModal.idModal}
      titleModal={buttonModal.titleModal}
      sizeModal="modal-lg"
      contentModal={<ModalContent buttonModal={buttonModal} />}
    />
  </div>
);

const ModalContent = ({ buttonModal }) => (
  <div>
    <h5 className="mb-0">Tema: </h5>
    {buttonModal.titleTheme}
    <h5 className="mt-3 mb-0">Palabras clave: </h5>
    {buttonModal.keyWords}
    <h5 className="mt-3 mb-0">Descripción: </h5>
    {buttonModal.description}
    <h5 className="mt-3 mb-0">Área responsable: </h5>
    {buttonModal.area}
    <h5 className="mt-3 mb-0">Última actualización:</h5>
    {buttonModal.dateUpdate}
    <h5 className="mt-3 mb-0">Responsable de los datos:</h5>
    {buttonModal.contactName}
    <h5 className="mt-3 mb-0">Correo electrónico: </h5>
    {buttonModal.contactEmail}
    <h5 className="mt-3 mb-0">Datos y recursos: </h5>
    {buttonModal.subChildren.map((content) => (
      <DocumentLink key={content.id} content={content} />
    ))}
  </div>
);

const DocumentLink = ({ content }) => {
  const icons = {
    pdf: faFilePdf,
    word: faFileWord,
    excel: faFileExcel,
  };

  const btnClasses = {
    pdf: "btn btn-danger",
    word: "btn btn-primary",
    excel: "btn btn-success",
  };

  return (
    <div className="mt-1 mb-1">
      <a
        href={content.resoursePath}
        target="_blank"
        rel="noreferrer"
        className={btnClasses[content.typeDocument]}
      >
        <FontAwesomeIcon icon={icons[content.typeDocument]} />
      </a>{" "}
      {content.resourseTitle}
    </div>
  );
};

export const DatosAbiertos = () => {
  const [openItem, setOpenItem] = useState(null);

  const handleAccordionClick = (id) => {
    setOpenItem((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    document.title = `Datos Abiertos`;
  }, []);

  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs path={[{ label: "Datos Abiertos" }]} />
        <TitlePages title="Datos Abiertos" subTitle="" />
        <div className="da-accordion-container" id="accordionDatosAbiertos">
          {dataDatosAbiertos.map((item) => (
            <AccordionItem
              key={item.id}
              item={item}
              isOpen={openItem === item.id}
              onClick={() => handleAccordionClick(item.id)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

// AccordionItem
AccordionItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    titleItem: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

// ModalButton
ModalButton.propTypes = {
  buttonModal: PropTypes.shape({
    idModal: PropTypes.string.isRequired,
    titleModal: PropTypes.string.isRequired,
    titleTheme: PropTypes.string,
    keyWords: PropTypes.string,
    description: PropTypes.string,
    area: PropTypes.string,
    dateUpdate: PropTypes.string,
    contactName: PropTypes.string,
    contactEmail: PropTypes.string,
    subChildren: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
};

ModalContent.propTypes = {
  buttonModal: PropTypes.shape({
    titleTheme: PropTypes.string,
    keyWords: PropTypes.string,
    description: PropTypes.string,
    area: PropTypes.string,
    dateUpdate: PropTypes.string,
    contactName: PropTypes.string,
    contactEmail: PropTypes.string,
    subChildren: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
};

DocumentLink.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    resoursePath: PropTypes.string.isRequired,
    typeDocument: PropTypes.oneOf(["pdf", "word", "excel"]).isRequired,
    resourseTitle: PropTypes.string.isRequired,
  }).isRequired,
};

export default DatosAbiertos;
